import IndexPage from './IndexPage'

export default IndexPage
// eslint-disable-next-line import/export
export * from './IndexPage'
